var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Kampagne löschen","action":"delete","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('div',{staticClass:"mt-4"},[_vm._v(" Kampagne \""+_vm._s(_vm.name)+"\" wirklich löschen ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }